import React, { useContext } from "react";
import "./We_partner.css";
import Pink_box from "../../common_components/pink_box/Pink_box";
import Common_subHeading from "../../common_components/common_subHeading/Common_subHeading";
import { Context } from "../../../utils/context";

function We_partner() {

  const {language} =useContext(Context);

  const partner = [
  { 
    heading: language == 1 
      ? "English taught programs" 
      : "Programmes enseignés en anglais" 
  },
  { 
    heading: language == 1 
      ? "Modern campuses with digital infrastructure" 
      : "Campus modernes avec des infrastructures numériques" 
  },
  { 
    heading: language == 1 
      ? "Highly qualified international faculty" 
      : "Corps professoral international hautement qualifié" 
  },
  { 
    heading: language == 1 
      ? "Internships integrated into the study curriculum" 
      : "Stages intégrés au cursus académique" 
  },
  { 
    heading: language == 1 
      ? "Supportive international student services" 
      : "Services d’accompagnement dédiés aux étudiants internationaux" 
  },
  { 
    heading: language == 1 
      ? "Safe and culturally rich locations" 
      : "Destinations sûres et culturellement riches" 
  },
];

  return (
    <section className="We_partner">
      <div className="container">

        {/* <Common_subHeading subHeading="What students can expect" /> */}
        <Common_subHeading 
  subHeading={
    language == 1 
      ? "What students can expect" 
      : "Ce à quoi les étudiants peuvent s'attendre"
  } 
/>

        <div className="pink_box_holder">
          <div className="row">

            {partner.map((item, index) => (
              <div className="col-xl-4 col-lg-4 col-md-3 col-sm-6 mb-4" key={index}>
                <Pink_box box_text={item.heading} />
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
}

export default We_partner;
